import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import Avatar from './Avatar.js';
import Icon, { IconTypes, IconColors } from './Icon.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import { u as useLocalization } from '../LocalizationContext-a82461b5.js';
import { f as format } from '../index-ccef08fe.js';
import { i as isToday, a as isYesterday, b as isThisYear } from '../index-f879f6ef.js';
import { d as isVoiceMessage } from '../index-579ca9d7.js';
import './ImageRenderer.js';
import '../uuid-717930b4.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import '../index-ad50e2c0.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../utils/message/getOutgoingMessageState.js';
function getCreatedAt(_ref) {
  var createdAt = _ref.createdAt,
    locale = _ref.locale,
    stringSet = _ref.stringSet;
  var optionalParam = locale ? {
    locale: locale
  } : null;
  if (!createdAt) {
    return '';
  }
  if (isToday(createdAt)) {
    return format(createdAt, 'p', optionalParam);
  }
  if (isYesterday(createdAt)) {
    return (stringSet === null || stringSet === void 0 ? void 0 : stringSet.MESSAGE_STATUS__YESTERDAY) || 'Yesterday';
  }
  if (isThisYear(createdAt)) {
    return format(createdAt, 'MMM d', optionalParam);
  }
  return format(createdAt, 'yyyy/M/d', optionalParam);
}
function getIconOfFileType(message) {
  var url = message.url;
  var fileMessageUrl = url;
  var fileExtension = fileMessageUrl.match(/\.([^.]*?)(?=\?|#|$)/)[1];
  if (/(jpg|jpeg|png)$/i.test(fileExtension)) {
    return IconTypes.PHOTO;
  } else if (/mp4$/i.test(fileExtension) || isVoiceMessage(message)) {
    return IconTypes.PLAY;
  } else if (/mp3/i.test(fileExtension)) {
    return IconTypes.FILE_AUDIO;
  } else if (/gif/i.test(fileExtension)) {
    return IconTypes.GIF;
  } else {
    return IconTypes.FILE_DOCUMENT;
  }
}
function MessageSearchFileItem(props) {
  var className = props.className,
    message = props.message,
    selected = props.selected,
    _onClick = props.onClick;
  var createdAt = message.createdAt,
    url = message.url,
    name = message.name; // @ts-ignore
  var sender = message.sender || message._sender;
  var profileUrl = sender.profileUrl,
    nickname = sender.nickname;
  var _useLocalization = useLocalization(),
    stringSet = _useLocalization.stringSet,
    dateLocale = _useLocalization.dateLocale;
  var isVoiceMsg = isVoiceMessage(message);
  var prettyFilename = isVoiceMsg ? stringSet.VOICE_MESSAGE : name || url;
  return /*#__PURE__*/React__default.createElement("div", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-message-search-file-item', selected ? 'sendbird-message-search-file-item--selected' : '']).join(' '),
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick(message);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-search-file-item__left"
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: "sendbird-message-search-file-item__left__sender-avatar",
    src: profileUrl,
    alt: "profile image",
    width: "56px",
    height: "56px"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-search-file-item__right"
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-message-search-file-item__right__sender-name",
    type: LabelTypography.SUBTITLE_2,
    color: LabelColors.ONBACKGROUND_1
  }, nickname || stringSet.NO_NAME), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-search-file-item__right__content"
  }, !isVoiceMsg && /*#__PURE__*/React__default.createElement("div", {
    className: 'sendbird-message-search-file-item__right__content__type-icon'
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: getIconOfFileType(message),
    fillColor: IconColors.PRIMARY,
    width: "18px",
    height: "18px"
  })), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-message-search-file-item__right__content__url",
    type: LabelTypography.BODY_2,
    color: LabelColors.ONBACKGROUND_1
  }, prettyFilename))), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-message-search-file-item__message-created-at",
    type: LabelTypography.CAPTION_3,
    color: LabelColors.ONBACKGROUND_2
  }, getCreatedAt({
    createdAt: createdAt,
    locale: dateLocale,
    stringSet: stringSet
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-search-file-item__right-footer"
  }));
}
export { MessageSearchFileItem as default };